import { render, staticRenderFns } from "./AppointmentData.vue?vue&type=template&id=51338808"
import script from "./AppointmentData.vue?vue&type=script&lang=js"
export * from "./AppointmentData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports